import { unMaskPrice } from '@/utils/common';

export class ApproveTransferStockPayload {
  /**
   * @param {Object} data
   * @param {String} data.id
   * @param {ApproveTransferStockProductPayload[]} data.listProduct
   * @param {String} data.destinationWarehouse
   * @param {String} data.description
   */
  constructor(data) {
    this.id = data.id;
    this.listProduct = data.listProduct;
    this.destinationWarehouse = data.destinationWarehouse;
    this.description = data.description;
  }

}

export class ApproveTransferStockProductPayload {
  constructor(data) {
    this.id = data.id;
    this.productId = data.productId;
    this.imeis = data.imeis;
    this.quantity = data.quantity;
    this.unitPrice = data.price;
    this.productBatchStockId = data.productBatchStockId;
  }
  formatImeisFromTextArea() {
    this.imeis = this.imeis.replace(/[\n\r]/g, ', ');
    return this;
  }

  unMaskPriceToNumber() {
    this.unitPrice = unMaskPrice(this.unitPrice);
    return this;
  }

  get() {
    return this;
  }
}
